import './App.css';
import Page from './Page/Page'
function App() {
  return (
    <div>
      <Page />
    </div>
  );
}

export default App;
